<div class="device-battery__filter-card">
  <div class="device-battery__filter-row">
    <dcc-billboard
      label="Devices"
      [value]="totalCount | number"></dcc-billboard>

    <input
      class="device-battery__filter"
      type="text"
      name="companyId"
      placeholder="Company ID"
      [(ngModel)]="companyId" />

    <select
      class="device-battery__filter"
      name="batteryType"
      [(ngModel)]="batteryType"
      (change)="onFilterChange()">
      <option
        disabled
        hidden
        [ngValue]="null">
        Battery Type
      </option>
      <option
        *ngFor="let opt of batteryTypeOptions"
        [ngValue]="opt.value">
        {{ opt.label }}
      </option>
    </select>

    <select
      class="device-battery__filter"
      name="batteryHealth"
      [(ngModel)]="batteryHealth"
      (change)="onFilterChange()">
      <option
        disabled
        hidden
        [ngValue]="null">
        Battery Health
      </option>
      <option
        *ngFor="let opt of batteryHealthOptions"
        [ngValue]="opt.value">
        {{ opt.label }}
      </option>
    </select>

    <select
      class="device-battery__filter"
      name="searchField"
      [(ngModel)]="searchField">
      <option
        *ngFor="let opt of searchFieldOptions"
        [value]="opt.value">
        {{ opt.label }}
      </option>
    </select>

    <input
      class="device-battery__filter"
      type="text"
      name="searchValue"
      placeholder="Select Search Criteria"
      [(ngModel)]="searchValue"
      (keyup.enter)="onSearchClick()" />

    <dcc-search-button (search)="onSearchClick()"></dcc-search-button>
    <dcc-reset-button (reset)="onResetClick()"></dcc-reset-button>

    <dcc-download-csv-button
      class="device-battery__download"
      [disabled]="!records.length"
      (download)="onDownloadCsv()"></dcc-download-csv-button>
  </div>

  <div class="device-battery__selection">
    <span class="device-battery__selected-count">{{ selectedCount }}</span>
    <span class="device-battery__selected-label">Selected</span>
    <button
      type="button"
      class="device-battery__link"
      (click)="onClearAll()">
      Clear All
    </button>
    <button
      type="button"
      class="device-battery__button"
      title="Select exactly one device to modify its settings"
      [disabled]="selectedCount !== 1"
      (click)="onModifySettings()">
      Modify Settings
    </button>
    <button
      type="button"
      class="device-battery__button"
      [disabled]="!selectedCount"
      (click)="onIssueCommands()">
      Issue Commands
    </button>
  </div>
</div>

<ag-grid-angular
  class="ag-theme-alpine ag-grid-sticky-header"
  domLayout="autoHeight"
  rowSelection="multiple"
  style="width: 100%; height: 100%"
  [columnDefs]="columnDefinitions"
  [defaultColDef]="defaultColumnConfiguration"
  [enableBrowserTooltips]="true"
  [enableCellTextSelection]="true"
  [ensureDomOrder]="true"
  [pagination]="false"
  [rowData]="records"
  [suppressRowClickSelection]="true"
  [suppressRowHoverHighlight]="true"
  (rowSelected)="onRowSelectionChanged($event)"></ag-grid-angular>

<dcc-spinner *ngIf="isLoading"></dcc-spinner>

<simple-paginator
  *ngIf="records?.length"
  [pageCount]="pageCount"
  [pageNumber]="pageNumber"
  (clickFirst)="onClickFirst()"
  (clickNext)="onPaginate()"></simple-paginator>
